import { connect } from 'react-redux';
import NewsEdit from './NewsEdit';
import newsCRUDAction from '../../../actions/news';

export default connect(
  state => ({
    loading: state.news.loadingItem
  }),
  dispatch => ({
    fetch: (id) => dispatch(newsCRUDAction.fetch(id))
  })
)(NewsEdit);



// WEBPACK FOOTER //
// ./src/components/News/NewsEdit/index.js